import { ContentChangeListener, ContentService } from '@volkswagen-onehub/audi-content-service';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import mockContent from '../sample-vendorCTA-content.json';
import mockPriceBreakdown from '../sample-priceBreakdownContent.json';
import { AppContent, mapContent } from '../ContentMapping/contentMapping';
import { getEnabledVendorCTAs } from '../utils/getEnabledVendorCTAs';
import { setVendorCTAs } from '../redux/vendorCTAsReducer';
import { setPriceBreakdowns } from '../redux/priceBreakdownReducer';

const useContentProcessor = (contentService?: ContentService) => {
  const [rawContent, setRawContent] = useState(contentService?.getContent() as AppContent);
  const dispatch = useDispatch();

  const content = mapContent(rawContent);
  contentService?.onContentChange(setRawContent as ContentChangeListener);

  useEffect(() => {
    if (content?.vendorCtaGroup?.length <= 0) return;

    const enabledCTAsOnly = getEnabledVendorCTAs(content);
    dispatch(setVendorCTAs(enabledCTAsOnly));
  }, [dispatch, content]);

  useEffect(() => {
    if (!content && Object.keys(content).length === 0) return;

    dispatch(setPriceBreakdowns(content));
  }, [dispatch, content]);
};

export default useContentProcessor;
